import React, { Component } from 'react';
import { Link } from '@reach/router';

class Navi extends Component {
    render() {
        const isActive = ({ isCurrent }) => {
            return isCurrent ? { className: 'item active' } : { className: 'item' }
        }
        const NavLink = props => (
            <Link getProps={isActive} {...props} />
        )
      return (
          <section className="menu">
            <nav className="stretch">
                <NavLink to="/day" className="item ">Day</NavLink>
                <NavLink to="/" className="item ">Week</NavLink>
                <NavLink to="/month" className="item ">Month</NavLink>
            </nav>
          </section>
      )
    }
  }

  export default Navi;